/**
Project: Voice Panel (c)
Title:Frame Error Frame
Description: Error Frame to be displayed when errors occured while accesing voice panel 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import {
    Flex,
    Text,
} from "@fluentui/react-northstar";

class ErrorFrame extends Component {
    _intl_ns_common = "common";
    _intl_ns_error = "error";

    render() {
        return (
            <div id="error-page">
                <div className="error-page-content">
                    <Flex column className="error-page-segment">
                        <Flex className="m-b-20">
                            <Text error size="large" className="text-bold text-uppercase">
                                Error
                            </Text>
                        </Flex>
                        <Flex className="m-b-30">
                            <Text size="medium">This content cannot be displayed in frame.</Text>
                        </Flex>
                    </Flex>
                </div>
            </div>
        )
    }
}

export default ErrorFrame